var _defs, _rect, _text, _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _text2, _text3, _text4, _text5, _line5, _line6, _circle4, _line7, _polygon, _text6, _rect2, _text7, _g, _g2, _g3, _rect3, _rect4, _rect5, _line8, _polygon2, _text8, _rect6, _text9, _text10, _text11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg6CronScheduler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 240",
    xmlns: "http://www.w3.org/2000/svg",
    width: 700,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n    @keyframes clock-tick{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}\n    @keyframes clock-min{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}\n    @keyframes job-drop{0%{opacity:0;transform:translateY(-20px)}20%{opacity:1;transform:translateY(0)}80%{opacity:1;transform:translateY(0)}100%{opacity:0;transform:translateY(20px)}}\n    @keyframes queue-scroll{0%{transform:translateX(0)}100%{transform:translateX(-50px)}}\n    @keyframes arrow-flash{0%,100%{opacity:.3}50%{opacity:1}}\n    .hand-h{transform-origin:360px 120px;animation:clock-tick 12s linear infinite}\n    .hand-m{transform-origin:360px 120px;animation:clock-min 1.5s linear infinite}\n    .j1{animation:job-drop 3s ease-in-out infinite 0s}\n    .j2{animation:job-drop 3s ease-in-out infinite 1s}\n    .j3{animation:job-drop 3s ease-in-out infinite 2s}\n    .arr{animation:arrow-flash 1s ease-in-out infinite}\n  "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#060912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#080f1c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q-clock-glow",
    cx: "50%",
    cy: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fb923c",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fb923c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q-glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 240,
    fill: "url(#q-bg)",
    rx: 20
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 24,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 10,
    letterSpacing: 2
  }, "CRON SCHEDULER \u2014 QUEUING NOTIFICATIONS BY PEAK HOUR")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 125,
    r: 80,
    fill: "url(#q-clock-glow)",
    filter: "url(#q-glow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 125,
    r: 68,
    fill: "#060912",
    stroke: "#fb923c",
    strokeWidth: 1.5,
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 125,
    r: 65,
    fill: "none",
    stroke: "#1a1200",
    strokeWidth: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 62,
    x2: 160,
    y2: 70,
    stroke: "#fb923c",
    strokeWidth: 2,
    opacity: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 223,
    y1: 125,
    x2: 215,
    y2: 125,
    stroke: "#fb923c",
    strokeWidth: 2,
    opacity: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 188,
    x2: 160,
    y2: 180,
    stroke: "#fb923c",
    strokeWidth: 2,
    opacity: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 97,
    y1: 125,
    x2: 105,
    y2: 125,
    stroke: "#fb923c",
    strokeWidth: 2,
    opacity: 0.6
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 82,
    textAnchor: "middle",
    fill: "#fb923c",
    fontFamily: "JetBrains Mono",
    fontSize: 10,
    opacity: 0.8
  }, "12")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 218,
    y: 130,
    textAnchor: "middle",
    fill: "#fb923c",
    fontFamily: "JetBrains Mono",
    fontSize: 10,
    opacity: 0.8
  }, "3")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 184,
    textAnchor: "middle",
    fill: "#fb923c",
    fontFamily: "JetBrains Mono",
    fontSize: 10,
    opacity: 0.8
  }, "6")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 130,
    textAnchor: "middle",
    fill: "#fb923c",
    fontFamily: "JetBrains Mono",
    fontSize: 10,
    opacity: 0.8
  }, "9")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "hand-h",
    x1: 160,
    y1: 125,
    x2: 160,
    y2: 88,
    stroke: "#fb923c",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "hand-m",
    x1: 160,
    y1: 125,
    x2: 160,
    y2: 74,
    stroke: "#fbbf24",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 125,
    r: 4,
    fill: "#fb923c",
    filter: "url(#q-glow)"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 232,
    y1: 125,
    x2: 270,
    y2: 125,
    stroke: "#334155",
    strokeWidth: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "270,120 280,125 270,130",
    fill: "#334155"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 255,
    y: 115,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "TRIGGER")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 80,
    width: 260,
    height: 90,
    rx: 10,
    fill: "#0a0f1e",
    stroke: "#1e293b",
    strokeWidth: 1.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 415,
    y: 74,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 9
  }, "JOB QUEUE")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "j1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 90,
    width: 70,
    height: 30,
    rx: 6,
    fill: "#0d2247",
    stroke: "#3b82f6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 103,
    textAnchor: "middle",
    fill: "#60a5fa",
    fontFamily: "JetBrains Mono",
    fontSize: 7
  }, "user_4821"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 114,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 7
  }, "9pm notif"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "j2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 90,
    width: 70,
    height: 30,
    rx: 6,
    fill: "#0d2247",
    stroke: "#7c3aed",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 103,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontFamily: "JetBrains Mono",
    fontSize: 7
  }, "user_2204"), /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 114,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 7
  }, "9pm notif"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "j3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 90,
    width: 70,
    height: 30,
    rx: 6,
    fill: "#0d2247",
    stroke: "#059669",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 103,
    textAnchor: "middle",
    fill: "#34d399",
    fontFamily: "JetBrains Mono",
    fontSize: 7
  }, "user_9033"), /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 114,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 7
  }, "9pm notif"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 130,
    width: 70,
    height: 30,
    rx: 6,
    fill: "#0a1628",
    stroke: "#1e293b",
    strokeWidth: 1,
    opacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 130,
    width: 70,
    height: 30,
    rx: 6,
    fill: "#0a1628",
    stroke: "#1e293b",
    strokeWidth: 1,
    opacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 130,
    width: 70,
    height: 30,
    rx: 6,
    fill: "#0a1628",
    stroke: "#1e293b",
    strokeWidth: 1,
    opacity: 0.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "arr",
    x1: 550,
    y1: 125,
    x2: 590,
    y2: 125,
    stroke: "#fb923c",
    strokeWidth: 2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "590,120 600,125 590,130",
    fill: "#fb923c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: ".3;1;.3",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 575,
    y: 115,
    textAnchor: "middle",
    fill: "#fb923c",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "WORKERS")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 605,
    y: 105,
    width: 75,
    height: 40,
    rx: 8,
    fill: "#0d1a2e",
    stroke: "#fb923c",
    strokeWidth: 1,
    opacity: 0.7
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 642,
    y: 121,
    textAnchor: "middle",
    fill: "#fb923c",
    fontFamily: "JetBrains Mono",
    fontSize: 10
  }, "\u26A1")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 642,
    y: 135,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "process")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 200,
    textAnchor: "middle",
    fill: "#1e293b",
    fontFamily: "JetBrains Mono",
    fontSize: 9
  }, "Jobs queued at exact peak hour \u2014 workers process instantly")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg6CronScheduler);
export default __webpack_public_path__ + "static/media/svg6-cron-scheduler.5607c037ccfedd2a42d316f7734e93ce.svg";
export { ForwardRef as ReactComponent };